/**
 * Parse color to r, g, b (0-255). Handles #hex and rgb(r,g,b).
 */
function parseToRgb(color: string): { r: number; g: number; b: number } {
  const t = color.trim();
  const rgbMatch = t.match(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
  if (rgbMatch) {
    return {
      r: parseInt(rgbMatch[1], 10),
      g: parseInt(rgbMatch[2], 10),
      b: parseInt(rgbMatch[3], 10),
    };
  }
  const hex = t.replace(/^#/, '');
  const match = hex.match(/(.{2})(.{2})(.{2})/);
  if (match) {
    return {
      r: parseInt(match[1], 16),
      g: parseInt(match[2], 16),
      b: parseInt(match[3], 16),
    };
  }
  if (hex.length === 3) {
    return {
      r: parseInt(hex[0] + hex[0], 16),
      g: parseInt(hex[1] + hex[1], 16),
      b: parseInt(hex[2] + hex[2], 16),
    };
  }
  return { r: 0, g: 0, b: 0 };
}

/**
 * Interpolate between two colors (hex or rgb). ratio 0 = color1, ratio 1 = color2.
 */
export function interpolateColor(
  color1: string,
  color2: string,
  ratio: number,
): string {
  const r1 = parseToRgb(color1);
  const r2 = parseToRgb(color2);
  const r = Math.round(r1.r + (r2.r - r1.r) * ratio);
  const g = Math.round(r1.g + (r2.g - r1.g) * ratio);
  const b = Math.round(r1.b + (r2.b - r1.b) * ratio);
  return `#${[r, g, b].map(x => x.toString(16).padStart(2, '0')).join('')}`;
}

/**
 * Get chip background color for event type by its index in ordered list.
 * First = primary, last = secondary, others interpolated.
 */
export function getEventTypeChipColor(
  index: number,
  total: number,
  primaryColor: string,
  secondaryColor: string,
): string {
  if (total <= 1) return primaryColor;
  const ratio = index / (total - 1);
  return interpolateColor(primaryColor, secondaryColor, ratio);
}
